// @ts-expect-error Variable replacement from DefinePlugin
export const mhaVersion = function () { return __VERSION__; };
